<!-- Contact Us Start -->
<section class="section" id="contac">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-8">
                <div class="title text-center mb-5">
                    <h3 class="font-weight-normal text-dark">Ponte en <span class="text-warning">Contacto</span></h3>
                    <p class="text-muted">Ponte en contacto con nosotros y pronto un especialista responderá tu solicitud.</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-4">
                <div class="contact-address">
                    <h4 class="text-dark mb-4">Chats</h4>
                    <p class="text-muted f-15">Puedes utilizar las plataformas más comúnes para comunicarte con nosostros.</p>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-6">
                        <div class="contact-address">
                            <h5 class="text-dark mb-3 f-16">Whatsapp</h5>
                            <a href="https://api.whatsapp.com/send?phone=50664845946&text=Buenas%20tardes%20requiero%20información" target="_blank"><img src="assets/logos/whatsapp.png" alt="" style="width: 80px;"></a>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6">
                        <div class="contact-address">
                            <h5 class="text-dark mb-3 f-16">Telegram</h5>
                            <a href="https://t.me/+50664845946" target="_blank"><img src="assets/logos/telegram.png" alt="" style="width: 80px;"></a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-7 offset-lg-1">
                <div class="custom-form mt-4 mt-lg-0">
                    <div id="message"></div>
          
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group app-label">
                                    <label for="name">Nombre</label>
                                    <input [(ngModel)]="form.nombre" (keyup)="verifyform()" type="text" class="form-control" placeholder="Tu nombre..">
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group app-label">
                                    <label for="email">Email</label>
                                    <input [(ngModel)]="form.email" (keyup)="verifyform()" type="email" class="form-control" placeholder="Tu email..">
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group app-label">
                                    <label for="subject">Asunto</label>
                                    <input [(ngModel)]="form.asunto" (keyup)="verifyform()" type="text" class="form-control" placeholder="El asunto.." />
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group app-label">
                                    <label for="comments">Mensaje</label>
                                    <textarea [(ngModel)]="form.mensaje" (keyup)="verifyform()"  rows="3" class="form-control" placeholder="Tu mensaje.."></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <button [disabled]="formBtn"  class="btn btn-warning" (click)="sendForm()">Enviar <i class="mdi mdi-telegram ml-2"></i></button>
                                <div id="simple-msg"></div>
                            </div>
                        </div>
             
                    <div class="sent" *ngIf="formSent">
                        <p>Solicitud Enviada</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Contact Us End -->

<!-- Subscribe Start -->
<section class="section bg-light">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-7">
                <div class="row">
                    <div class="col-4">
                        <div class="subscribe-icon">
                            <img src="assets/images/icon/1.png" alt="" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="subscribe-icon">
                            <img src="assets/images/icon/2.png" alt="" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="">
                            <img src="assets/images/icon/3.png" alt="" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-6">
                <div class="text-center mt-5 mb-4">
                    <h6 class="text-muted font-weight-normal">Suscribete para recibir información de ofertas y actualizaciones, <span class="d-block mt-2">Es gratis!</span></h6>
                </div>
                <div class="text-center subscribe-form mt-4">  
                    <input type="email" placeholder="Tu email" [(ngModel)]="suscrip" (keyup)="verifySuscrip()">
                    <button [disabled]="suscripBtn"  class="btn btn-warning" (click)="sendSuscrib()">Subscribir</button>
                </div>
                <div class="sent" *ngIf="susSent">
                    <p>Suscripción Realizada</p>
                </div>
            </div>
        </div>

    </div>
</section>
<!-- Subscribe End -->